module.exports = __webpack_public_path__ + "NotoSans-Bold.woff?4e303ca2a3012ae459fbc1dd6af1425a";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/fonts/NotoSans-Bold.woff
// module id = 1230
// module chunks = 6